<form [formGroup]="formGroup" *ngIf="showVersicherungsbestaetigung" appPropagateSubmit [parentFormGroupDirective]="parentFormGroupDirective">
  <div *ngIf="!antrag; then versicherungsbestaetigungTitle; else versicherungsbestaetigung"></div>
  <ng-template #versicherungsbestaetigungTitle>
    <div class="mt-3">
      <h6>Versicherungsbestätigung</h6>
      <div class="row">
        <div class="col col-xs-12 col-sm-12">
          <ng-template *ngTemplateOutlet="versicherungsbestaetigungTemplate"></ng-template>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #versicherungsbestaetigung>
    <div>
      <ng-template *ngTemplateOutlet="versicherungsbestaetigungTemplate"></ng-template>
    </div>
  </ng-template>
  <ng-template #versicherungsbestaetigungTemplate>
    <div class="row">
      <div class="col col-xs-12 col-sm-12">
        <div class="teaser" *ngIf="(translateService.get('VBTEASERINFO') | async) as res" [innerHTML]="res"></div>
        <ng-template #vbvergabeartLabelTemplate>
          <app-label [control]="vbvergabeart" class="custom-select__label" [for]="antrag ? 'antrag' : 'offert' + '_vbvergabeart'">{{ expertMode ? 'Hinterlegung der Versicherungsbestätigung durch:' : 'Wie möchten Sie Ihre Versicherungsbestätigung, gültig ab ' + (beginndatum | date) + ', erhalten?' }}</app-label>
        </ng-template>
        <div *ngIf="expertMode; then vbvergabeartExpert; else _vbvergabeart"></div>
        <ng-template #vbvergabeartExpert>
          <div class="dynamic-flex-horizontal">
            <div class="input">
              <ng-template *ngTemplateOutlet="vbvergabeartLabelTemplate"></ng-template>
              <mat-form-field>
                <mat-select [id]="antrag ? 'antrag' : 'offert' + '_vbvergabeart'" [placeholder]="translateService.get('SELECTPLACEHOLDER') | async" formControlName="vbvergabeart">
                  <mat-option *ngFor="let vbvergabeart of vbvergabearten | keyvalue: keyValueService.unsorted" [value]="vbvergabeart.key">{{ vbvergabeart.value }}</mat-option>
                </mat-select>
                <mat-error *ngIf="vbvergabeart.hasError('required') && parentFormGroupDirective.submitted">{{ 'SELECTREQUIRED' | translate }}</mat-error>
              </mat-form-field>
            </div>
            <div class="input" *ngIf="showVbnummer">
              <app-label [control]="vbnummer" class="input__label" [for]="antrag ? 'antrag' : 'offert' + '_vbnummer'" for="antrag_vbnummer">Nummer der Versicherungsbestätigung:</app-label>
              <mat-form-field>
                <input matInput [id]="antrag ? 'antrag' : 'offert' + '_vbnummer'" formControlName="vbnummer">
              </mat-form-field>
            </div>
          </div>
        </ng-template>
        <ng-template #_vbvergabeart>
          <div class="input_radio">
            <ng-template *ngTemplateOutlet="vbvergabeartLabelTemplate"></ng-template>
            <mat-radio-group class="vertical-radio-group" [id]="antrag ? 'antrag' : 'offert' + '_vbvergabeart'" formControlName="vbvergabeart">
              <ng-template ngFor let-vbvergabeart [ngForOf]="vbvergabearten | keyvalue: keyValueService.unsorted">
                <div class="text_info height-auto">
                  <mat-radio-button [value]="vbvergabeart.key">{{ vbvergabeart.value }}</mat-radio-button>
                  <div *ngIf="vbvergabeart.key === 2 || vbvergabeart.key === 3" class="info">
                    <div class="info_trigger icon--before icon--info" *ngIf="(translateService.get(vbvergabeart.key === 3 ? 'VBDIREKTINFO' : 'VBHDIINFO') | async) as res" (click)="popupService.openInfoPopup(res)"></div>
                  </div>
                </div>
              </ng-template>
            </mat-radio-group>
            <mat-error *ngIf="vbvergabeart.hasError('required') && parentFormGroupDirective.submitted">{{ 'SELECTREQUIRED' | translate }}</mat-error>
          </div>
        </ng-template>
      </div>
      <div class="col col-xs-12 col-sm-12">
        <div class="custom_select" *ngIf="showLdstelle">
          <app-label [control]="ldstelle" class="custom-select__label" [for]="antrag ? 'antrag' : 'offert' + '_ldstelle'">Wählen Sie Ihr nächstgelegenes HDI Kundenbüro:</app-label>
          <mat-form-field>
            <mat-select [id]="antrag ? 'antrag' : 'offert' + '_ldstelle'" [placeholder]="translateService.get('SELECTPLACEHOLDER') | async" formControlName="ldstelle" [compareWith]="lookupService.compareValues">
              <mat-option *ngFor="let ld of (ldstellen | async)?.Ldstellen" [value]="ld">{{ ld.Value }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
  </ng-template>
</form>
